import React from "react";

export default function InsightsEmptyState() {
  return (
    <div
      className="flex flex-col items-center justify-center flex-1 py-16 px-4 min-h-[400px]"
      style={{ fontFamily: "Inter, sans-serif", backgroundColor: "transparent" }}
    >
      <div className="w-[280px] h-[180px] mb-8 flex items-center justify-center" style={{ color: "color-mix(in srgb, var(--brand-primary) 25%, transparent)" }}>
        <svg
          viewBox="0 0 280 180"
          className="w-full h-full"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M20 160 L60 120 L100 140 L140 80 L180 100 L220 60 L260 90" />
          <path d="M20 100 L80 80 L140 60 L200 90" strokeDasharray="4 4" opacity="0.6" />
          <circle cx="140" cy="90" r="8" fill="currentColor" opacity="0.4" />
        </svg>
      </div>
      <p className="text-lg font-medium text-center" style={{ color: "var(--text-primary)" }}>
        Select an Event or Cohort to get started.
      </p>
    </div>
  );
}
